import { isDesktop } from 'js/utils/deviceDetection';

export const setBodyBackgroudColor = (color) => {
  isDesktop() !== 'desktop' && (document.body.style.backgroundColor = color);
};

export const getBasePath = () => {
  const { pathname } = window.location;

  // Find the known project folder and extract up to it
  const marker = 'game-420-outdoor-learning-resource';
  const index = pathname.indexOf(marker);

  if (index !== -1) {
    return pathname.slice(0, index + marker.length);
  }

  return '/';
};
